/**
 * WordPress dependencies
 */
import { store, getContext } from "@wordpress/interactivity";

const { state, actions } = store("webx-post-collector", {
    state: {
        collection:
            JSON.parse(localStorage.getItem("webx-post-collector")) || [],
        get isLikedPostsEmpty() {
            return state.collection.length === 0;
        },
    },
    actions: {
        toggle: () => {
            //set isOpen to the opposite of its current value
            getContext().isOpen = !getContext().isOpen;
        },
        removeItem: () => {
            const { collection } = state;
            const context = getContext();
            //remove context from collection
            const newCollection = collection.filter(
                (post) => post.id !== context.item.id,
            );
            state.collection = newCollection;
            //save collection to local storage
            localStorage.setItem(
                "webx-post-collector",
                JSON.stringify(state.collection),
            );
        },
        updatePosts: () => {
            const { collection } = state;
            if (!collection.length) {
                actions.emptyLocalStorage();
                return;
            }
            const baseUrl = window.location.origin;
            const includeParam = collection.map((post) => post.id).join(",");

            const url = `${baseUrl}/wp-json/webx/v1/posts?include=${includeParam}`;
            //collection is an array of post ids. get post titles from the server
            fetch(url)
                .then((response) => response.json())
                .then((posts) => {
                    //save all post ids as collection
                    state.collection = posts.map((post) => post);
                    //overwrite collection with all post ids that are not in the response
                    //save collection to local storage
                    localStorage.setItem(
                        "webx-post-collector",
                        JSON.stringify(state.collection),
                    );
                    document.cookie = `webx-post-collector=${JSON.stringify(
                        state.collection,
                    )}`;
                });
        },
        emptyLocalStorage: () => {
            state.collection = [];
            localStorage.removeItem("webx-post-collector");
        },
        view: () => {
            const basketPage = getContext().basketPage;
            const { collection } = state;

            const includeParam = collection.map((post) => post.id).join(",");
            
            const url = `${basketPage}?basketItems=${includeParam}`;

            window.location.href = url;

        }
    },
});
